import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'app-show-more-paragraph',
  templateUrl: './app-show-more-paragraph.component.html',
  styleUrls: ['./app-show-more-paragraph.component.scss'],
})
export class AppShowMoreParagraphComponent implements OnInit {
  showMore = false
  @Input() text = ''
  constructor() {}

  ngOnInit(): void {}
}
